export interface OdsItem {
  id: number;
  label: string;
  color: string;
}

/** Cores oficiais dos 17 ODS da ONU. */
export const ODS_ITEMS: OdsItem[] = [
  { id: 1, label: 'Erradicação da pobreza', color: '#E5243B' },
  { id: 2, label: 'Fome zero e agricultura sustentável', color: '#DDA63A' },
  { id: 3, label: 'Saúde e bem-estar', color: '#4C9F38' },
  { id: 4, label: 'Educação de qualidade', color: '#C5192D' },
  { id: 5, label: 'Igualdade de gênero', color: '#FF3A21' },
  { id: 6, label: 'Água potável e saneamento', color: '#26BDE2' },
  { id: 7, label: 'Energia limpa e acessível', color: '#FCC30B' },
  { id: 8, label: 'Trabalho decente e crescimento econômico', color: '#A21942' },
  { id: 9, label: 'Indústria, inovação e infraestrutura', color: '#FD6925' },
  { id: 10, label: 'Redução das desigualdades', color: '#DD1367' },
  { id: 11, label: 'Cidades e comunidades sustentáveis', color: '#FD9D24' },
  { id: 12, label: 'Consumo e produção responsáveis', color: '#BF8B2E' },
  { id: 13, label: 'Ação contra a mudança global do clima', color: '#3F7E44' },
  { id: 14, label: 'Vida na água', color: '#0A97D9' },
  { id: 15, label: 'Vida terrestre', color: '#56C02B' },
  { id: 16, label: 'Paz, justiça e instituições eficazes', color: '#00689D' },
  { id: 17, label: 'Parcerias e meios de implementação', color: '#19486A' },
];

export const ODS_TOTAL = ODS_ITEMS.length;
